import React from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Video() {
  const {
    t
  } = useLanguage();
  return <section id="video" className="py-20 lg:py-[120px] px-8 lg:px-[60px] max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-[1fr_1.4fr] gap-16 lg:gap-[100px] items-center" data-id="element-284">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.9,
      ease: [0.16, 1, 0.3, 1]
    }} data-id="element-285">
        <p className="font-sans text-[10px] tracking-[6px] uppercase text-crimson-glow font-medium mb-6 flex items-center gap-5 before:content-[''] before:w-[40px] before:h-px before:bg-gradient-to-r before:from-crimson-glow before:to-transparent opacity-90" data-id="element-286">
          {t('video.label')}
        </p>
        <h2 className="font-serif text-[36px] sm:text-[44px] lg:text-[64px] font-medium leading-[1.05] tracking-[-0.02em] text-white mb-8" data-id="element-287">
          {t('video.headline')}
        </h2>
        <p className="font-sans text-[15px] lg:text-[17px] leading-[1.9] text-white/50 font-light tracking-[0.02em] max-w-[600px]" data-id="element-288">
          {t('video.body')}
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.9,
      ease: [0.16, 1, 0.3, 1],
      delay: 0.2
    }} className="relative aspect-video bg-charcoal2 border border-glass-border rounded-sm overflow-hidden cursor-pointer group" data-id="element-289">
        <div className="absolute inset-0 video-bg z-0" data-id="element-290"></div>
        <video src="https://cdn.magicpatterns.com/uploads/gVaSCcVuhAzd4PJEEuebTh/video-83d040f5-916b-402d-b1e3-c4fd5ef83c69.mp4" autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover opacity-95 group-hover:opacity-100 brightness-125 contrast-110 saturate-110 transition-opacity duration-500 z-[1]" data-id="element-291" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent z-[2]" data-id="element-292"></div>

        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[100px] h-[100px] border border-crimson/30 rounded-full animate-ring-pulse" data-id="element-293"></div>

        <div className="absolute bottom-6 left-6 right-6 flex justify-between items-center z-10" data-id="element-294">
          <span className="text-[9px] tracking-[3px] uppercase text-[#f5f5f5]/30" data-id="element-295">
            {t('video.tag')}
          </span>
        </div>
      </motion.div>
    </section>;
}